import { render, staticRenderFns } from "./ConferenceSportHealth.vue?vue&type=template&id=3146816e"
import script from "./ConferenceSportHealth.vue?vue&type=script&lang=js"
export * from "./ConferenceSportHealth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports